import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6db4c6ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-name" }, "睦邻活动", -1))
const _hoisted_3 = { class: "item-middle" }
const _hoisted_4 = { class: "item-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "item-time" }
const _hoisted_8 = {
  key: 0,
  class: "item-right"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment-warp" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("马上"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("报名 ")
], -1))

import { ref, computed } from "vue";
import { useRouter } from 'vue-router'

import runEvn from "@/modular/runEvn/RunEvn";

export default /*#__PURE__*/_defineComponent({
  __name: 'OfficialActivitie',
  props: {
    itemData: Object,
    /**
     * 是否有虚线，最后一个不要
     */
    notBorder: Boolean
},
  setup(__props) {

const fileBaseUrl = runEvn().fileBaseUrl;
const contentRef = ref();
const router = useRouter();

const props = __props;

// function goDetails() {
//     router.push(`/mulin/mutualAid/Details/${props.itemData.id}`);
// }
function goDetails() {
    router.push({
        path: `/mulin/appointment/Details/${props.itemData.id}`,
        query: {
            helpActType: props.itemData.helpActType,
        },
    });
}
// 窗口宽度，减去其他宽度 10 + 50 + ？ + 70 + 10
// 剩余宽度除以一个字12宽度，两行，减去日期的宽度
const contentWidth = document.documentElement.clientWidth - 140;
const lineFontLen = contentWidth / 12 * 2 - 8;

const content = computed(() => {

    if (!props.itemData.content) {
        return '';
    }
    return props.itemData.content?.length < lineFontLen ? props.itemData.content :
        props.itemData.content.substr(0, lineFontLen - 3) + '...';
})

const img = (key: string) => fileBaseUrl + key;
const dicTag = {
    "主题活动": "主题活动",
    "自由活动": "自由活动",
};
const tagText = () => dicTag[props.itemData.activityClass];

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["warp", { 'not-border': props.notBorder }])
  }, [
    _createElementVNode("div", {
      class: "item",
      onClick: goDetails
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_image, {
          class: "item-img",
          alt: "图片加载中...",
          fit: "cover",
          src: img(props.itemData.img),
          radius: "50%"
        }, null, 8, ["src"]),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.itemData.title), 1),
        _createElementVNode("div", {
          class: "item-content",
          ref_key: "contentRef",
          ref: contentRef
        }, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.itemData.createTimeStamp?.format('yyyy-MM-dd HH:mm')), 1)
        ], 512)
      ]),
      (props.itemData.activityStatus==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_van_tag, {
              size: "medium",
              class: "tag",
              plain: "",
              round: "",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tagText()), 1)
              ]),
              _: 1
            }),
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})